module.exports = "\n\n<div class=\"topnav\" id=\"myTopnav\">\n  <a href=\"/\" id=\"logo\"><img src=\".././assets/img/logo.png\" id=\"navbar-logo\"></a>\n  <a href=\"javascript:void(0);\" class=\"icon\" (click)=\"responsiveNavbar()\">\n    <i class=\"fa fa-bars\"></i>\n    </a>\n    <a href=\"men\">MEN</a>\n    <a href=\"womens\">WOMEN</a>\n    <a href=\"boys\">BOYS</a>\n    <a href=\"girls\">GIRLS</a>\n    <a routerLink=\"shoes\">SHOES</a>\n    <a href=\"#\">OUTLET</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/marketplace/marketplace.component.html
// module id = ../../../../../src/app/marketplace/marketplace.component.html
// module chunks = main